/* eslint-disable no-param-reassign */
import React, { useEffect, useRef, useState } from 'react';
import FontSelector from './FontSelector';
import SignatureDraw from './SignatureDraw';
import SignatureText from './SignatureText';
import './Signature.scss';

/** @type {TypeMePlease}} */
const Signature = React.forwardRef((props, ref) => {
  const {
    displayWidth,
    displayHeight,
    signingMethod,
    actualWidth,
    actualHeight,
    color,
    text,
    defaultFont,
    defaultData,
    showLine,
    croppedImg,
    selectFontMode,
    setSelectFontMode,
    readOnly,
    onSignatureChange
  } = props;
  const [initialText] = useState(text);
  const [font, setFont] = useState(defaultFont || 'Sofia');

  const signatureDrawRef = useRef();
  const signatureTextRef = useRef();

  useEffect(() => {
    ref.current = {
      getValue: async () => {
        const newValue = {};
        if (signingMethod === 0) {
          newValue.Data = signatureDrawRef.current.toData();

          if (!newValue.Data || newValue.Data.length === 0) {
            return null;
          }

          newValue.DataUri = signatureDrawRef.current.toDataURL();
        } else if (signingMethod === 1) {
          if (!text) {
            return null;
          }

          newValue.DataUri = await signatureTextRef.current.toDataURL();
          newValue.Text = text;
          newValue.Font = font;
        }
        return newValue;
      },
      hasChanged: () => {
        if (signingMethod === 0) {
          return signatureDrawRef.current.hasChanged();
        } else if (signingMethod === 1) {
          return initialText !== text || defaultFont !== font;
        }
        return true;
      },
      clearDrawing: () => {
        if (signatureDrawRef.current) {
          signatureDrawRef.current.clear();
        }
      },
      hasValue: () => {
        if (signingMethod === 0) {
          return signatureDrawRef.current.toData().length > 0;
        } else if (signingMethod === 1) {
          return text.length > 0;
        }
      }
    };
  });

  useEffect(() => {
    setFont(defaultFont || 'Sofia');
  }, [defaultFont]);

  return (
    <div className="signature" style={{ width: `${displayWidth}px`, height: `${displayHeight}px` }}>
      {signingMethod === 1 && selectFontMode ? (
        <FontSelector
          selectedFont={font}
          onSelect={(f) => {
            setFont(f);
            setSelectFontMode(false);
          }}
          previewText={text}
        />
      ) : (
        <>
          {croppedImg ? (
            <img src={croppedImg} style={{ position: 'absolute', pointerEvents: 'none', width: `${displayWidth}px`, height: `${displayHeight}px` }} />
          ) : null}
          {signingMethod === 0 ? (
            <SignatureDraw
              displayWidth={displayWidth}
              displayHeight={displayHeight}
              actualWidth={actualWidth}
              actualHeight={actualHeight}
              color={color}
              ref={signatureDrawRef}
              showLine={showLine}
              defaultValue={defaultData}
              readOnly={readOnly}
              onSignatureChange={onSignatureChange}
            />
          ) : (
            <SignatureText
              displayWidth={displayWidth}
              displayHeight={displayHeight}
              actualWidth={actualWidth}
              actualHeight={actualHeight}
              color={color}
              text={text}
              fontName={font}
              ref={signatureTextRef}
              showLine={showLine}
            />
          )}
        </>
      )}
    </div>
  );
});

export default Signature;
